import { useState } from 'react';
import { useSelector } from 'react-redux';

import Form from 'app/components/Form';
import { formatOptions } from 'app/utils/options';

const CatalogForm = props => {
  const {
    job,
    onClose,
    onSubmit,
    action,
    kiosks,
    jobConfigs
  } = props;

  const account = useSelector(state => state.portalReducer.account);
  const showProduct = account.feature_flags.catalog_products;

  const kioskOptions = formatOptions(kiosks);

  // filter out Digital Delivery (catalogs have None option instead)
  const jobConfigOptions = formatOptions(jobConfigs.filter(jc => jc.id !== -1));

  let header = null;
  if (action === 'update') {
    header = 'Edit Fields';
  }

  // disable event ID field unless creating a new job
  let eventIdDisabled = !!job;

  let fields = [
    { name: 'name', label: 'Catalog name', type: 'text', value: job?.name, helperText: 'This will become the name of the kiosk catalog', required: true  },
    { name: 'event_id', label: 'Catalog ID', type: 'text', value: job?.event_id, disabled: eventIdDisabled, helperText: "Unique ID for the catalog (can't be changed)", required: true },
    { name: 'kiosk_id', label: 'Kiosk', type: 'select', value: job?.kiosk_id, valueType: 'integer', options: kioskOptions, helperText: 'Assign catalog to kiosk', hideNoneOption: true }
  ]

  if (showProduct) {
    fields.push({ name: 'job_config_id', label: 'Product', type: 'select', value: job?.job_config_id, valueType: 'integer', options: jobConfigOptions, helperText: 'Product configuration for the catalog' });
  }

  return (
    <Form {...{
      header,
      fields,
      action,
      onClose,
      onSubmit
    }} />
  );
}

export default CatalogForm;
